import { API } from "aws-amplify";

export default (trackuuid) => API.del("admin", `/admin/tracks/${trackuuid}`);
